export default "__VITE_ASSET__YD4ZpDLemYmvNVhhWopmPA__"